import { Typography } from "@material-tailwind/react"

export const ResultHeader = ({ displayDoc, fullName, companyName, message }) => (
  <>
    {displayDoc && <Typography className="text-xl font-medium">{displayDoc}</Typography>}
    {fullName && <Typography className="text-lg">{fullName}</Typography>}
    {companyName && <Typography className="text-lg">{companyName}</Typography>}
    <Typography className="text-2xl font-bold underline">{message}</Typography>
  </>
)
